export const FETCH_TICKET_LIST_REQUEST = "GET_TICKET_LIST";
export const FETCH_TICKET_LIST_SUCCESS = "GET_TICKET_LIST_SUCCESS";
export const FETCH_TICKET_LIST_FAILURE = "GET_TICKET_LIST_FAILURE";

export const FETCH_TICKET_DETAILS_REQUEST = "GET_TICKET_DETAILS_REQUEST";
export const FETCH_TICKET_DETAILS_SUCCESS = "GET_TICKET_DETAILS_SUCCESS";
export const FETCH_TICKET_DETAILS_FAILURE = "GET_TICKET_DETAILS_FAILURE";


export const CREATE_TICKET_BOOKING_REQUEST = "CREATE_TICKET_BOOKING_REQUEST";
export const CREATE_TICKET_BOOKING_SUCCESS = "CREATE_TICKET_BOOKING_SUCCESS";
export const CREATE_TICKET_BOOKING_FAILURE = "CREATE_TICKET_BOOKING_FAILURE";

export const UPDATE_TICKET_PAYMENT_REQUEST = "UPDATE_TICKET_PAYMENT_REQUEST";
export const UPDATE_TICKET_PAYMENT_SUCCESS = "UPDATE_TICKET_PAYMENT_SUCCESS";
export const UPDATE_TICKET_PAYMENT_FAILURE = "UPDATE_TICKET_PAYMENT_FAILURE";

export const FETCH_MY_TICKET_REQUEST = "FETCH_MY_TICKET_REQUEST";
export const FETCH_MY_TICKET_SUCCESS = "FETCH_MY_TICKET_SUCCESS";
export const FETCH_MY_TICKET_FAILURE = "FETCH_MY_TICKET_FAILURE";

export const FETCH_MY_TICKET_DETAILS_REQUEST = "FETCH_MY_TICKET_DETAILS_REQUEST";
export const FETCH_MY_TICKET_DETAILS_SUCCESS = "FETCH_MY_TICKET_DETAILS_SUCCESS";
export const FETCH_MY_TICKET_DETAILS_FAILURE = "FETCH_MY_TICKET_DETAILS_FAILURE";

export const TICKET_DOWNLOAD_INVOICE_REQUEST = "TICKET_DOWNLOAD_INVOICE_REQUEST";
export const TICKET_DOWNLOAD_INVOICE_SUCCESS = "TICKET_DOWNLOAD_INVOICE_SUCCESS";
export const TICKET_DOWNLOAD_INVOICE_FAILURE = "TICKET_DOWNLOAD_INVOICE_FAILURE";

export const CANCEL_TICKET_REQUEST = "CANCEL_TICKET_REQUEST";
export const CANCEL_TICKET_SUCCESS = "CANCEL_TICKET_SUCCESS";
export const CANCEL_TICKET_FAILURE = "CANCEL_TICKET_FAILURE"


